import { Rectangle } from 'pixi.js';
import { EVENTS } from '../../lib/constants';
import { GameConfigs } from '../../lib/globals/GameConfigs';
import HELPERS from '../../lib/globals/helpers/Helpers';
import { isDesktop } from 'react-device-detect';
// import { InfoView } from "../../view/info/InfoView"
let desk = isDesktop ? 1 : 2;
const events = [
	EVENTS.ERROR_PAGE,
	EVENTS.BONUS_ROUND_STATE,
	EVENTS.SETTINGS_UPDATE,
	EVENTS.MODAL
];
class InfoController {
	constructor(vc, conf) {
		this.vc = vc;
		this.config = conf;
		this.enabled = false;
		if (this.vc.infobuttons) {
			this.item = this.vc.infobuttons[this.config.modal];
			this.item.handler = this.handler.bind(this);

			// this.rect = new Graphics();

			// this.rect.clear();
			// this.rect.beginFill(0xffff00, 0);
			// this.rect.lineStyle(2, 0xff0000);
			// this.rect.drawRect(-30, -50, 70, 100);

			// this.item.addChild(this.rect);
			this.item.hitArea = new Rectangle(
				-30 / desk,
				-30 / desk,
				70 / desk,
				70 / desk
			);
			this.addEventListeners();
			window.addEventListener(EVENTS.BONUS_BUY, this, false);
			this.checkbonus();
		} else {
			throw new Error(
				'CloseController failed init ' + JSON.stringify(this.config)
			);
		}
	}

	checkbonus() {
		if (GameConfigs.config.hasbonus) {
			this.item.interactive = false;
			// window.removeEventListener('keydown', this, false);
		} else {
			this.item.interactive = true;
		}
	}

	addEventListeners() {
		events.forEach((event) => window.addEventListener(event, this, false));
		if (
			GameConfigs.settings.keyboard_shortcuts &&
			!window.isMobile &&
			!window.isTablet
		) {
			this.enabled = true;
			window.addEventListener('keydown', this, false);
		}
	}
	handleEvent(evt) {
		switch (evt.type) {
			case EVENTS.ERROR_PAGE:
				if (evt.detail.error) {
					this.removeEvents();
					window.removeEventListener(EVENTS.BONUS_BUY, this, false);
				}
				break;
			case EVENTS.BONUS_BUY:
				if (evt.detail.bonus) {
					this.item.interactive = false;
				} else {
					this.item.interactive = true;
				}
				break;
			case EVENTS.BONUS_ROUND_STATE:
				if (evt.detail.state === 'started') {
					this.item.interactive = true;
					// window.addEventListener('keydown', this, false);
				}
				break;
			case 'keydown':
				if (evt.keyCode === 73) {
					if (this.enabled && this.item.interactive) {
						this.handler();
					}
				}
				if (evt.keyCode === 27 || evt.keyCode === 32) {
					if (this.enabled) {
						if (GameConfigs.modal === 'info') {
							this.handleModal('');
						}
					}
				}
				break;
			case EVENTS.SETTINGS_UPDATE:
				if (window.isMobile || window.isTablet) return;
				if (evt.detail.data.keyboard_shortcuts === undefined) return;
				if (evt.detail.data.keyboard_shortcuts) {
					if (this.enabled) return;
					this.enabled = true;
					window.addEventListener('keydown', this, false);
				} else {
					this.enabled = false;
					window.removeEventListener('keydown', this, false);
				}
				break;
			case EVENTS.MODAL:
				if (!window.isMobile && !window.isTablet) return;
				if (
					evt.detail.modal === 'settings' ||
					evt.detail.modal === 'quest' ||
					evt.detail.modal === 'quest_claim' ||
					GameConfigs.bonusBuy
				) {
					this.item.interactive = false;
				} else this.item.interactive = true;
				break;
			default:
				break;
		}
	}

	handleModal(e) {
		HELPERS.dispatchCustomEvent(EVENTS.MODAL, { modal: e });
	}

	handler() {
		if (
			GameConfigs.disabled.info ||
			(GameConfigs.isFreeSpin && GameConfigs.freeSpinLocal.show)
		)
			return;
		if (GameConfigs.modal === 'info') {
			this.handleModal('');
		} else {
			this.handleModal('info');
		}
	}

	removeEvents() {
		this.item.interactive = false;
		events.forEach((event) => window.removeEventListener(event, this, false));
		window.removeEventListener('keydown', this, false);
	}
}

export default InfoController;
